import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';
import { formatDate } from '../helpers';

export const savePreUserPaymentTransactionRequest = (body) => {
    const config = {
        path: 'paymentTransaction/preuser',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const getPaymentTransactionRequest = (idTransaction) => {
    const config = {
        path: `paymentTransaction/${idTransaction}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const preUserApplyPaymentTransactionRequest = (idTransaction, packageId) => {  
    const config = {
        path: `paymentTransaction/apply/${idTransaction}/new`,
        method: 'POST',
        headers: {
            packageId
        }
    };
    return FetchByObjectConfig(config);
}

export const saveUserPaymentTransactionRequest = (body) => {
    const config = {
        path: 'PaymentTransaction',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const userApplyPaymentTransactionRequest = (idTransaction, packageId) => {
    const config = {
        path: `paymentTransaction/apply/${idTransaction}/`,
        method: 'POST',
        headers: {
            packageId
        }
    };
    return FetchByObjectConfig(config);
}

export const createPaymentTokenRequest = (body) => {
    const config = {
        path: 'paymentTransaction/createPaymentToken',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const saveUserFreePackageRequest = (body) => {
    const config = {
        path: 'paymentTransaction/preuser',
        method: 'POST',
        body,
    };
    return FetchByObjectConfig(config);
}

export const stampPackageRequest = (body) => {
    const { emailAddresses, taxId, receiptUsage, fiscalName  } = body;
    const config = {
        path: 'billing/stamp',
        method: 'POST',
        body: {
            emails: emailAddresses,
            rfc: taxId,
            usoCfdi:receiptUsage,
            nombre: fiscalName,
            fechaCompra: new Date()
        }
    };
    return FetchByObjectConfig(config);
}